import { Col, Row } from "antd";
import Styled from "styled-components";

const AlreadyRegisteredContainer = Styled.div`
width:300px;	
		padding-bottom:10px;
		border-bottom: 1px solid #D4D4D4;
		text-align: center;
		
`;
const FooterModalWrapper = Styled.div`
display: flex;
flex-direction:column;
align-items: center;
		.signup__already-registered-anchor {
			color:#145AB4
		}
		
		.noregistry__ticket-label{
		font-weight:700;
		text-decoration: underline;
		color:#145AB4
		
	}

	
`;
const RegistryWrapper = Styled.a`
		color:"#145AB4";
		font-weight: 700;

`;

const TextCol = Styled(Col)`
	display: flex;
	flex-direction:column;
	text-align: center;
	margin-bottom: 32px;
	align-items:center;
	
`;

const Wrapper = Styled(Row)`
	justify-content:center;
	.title__login-modal {
		font-weight: 800;
		font-size:16px;
		color:#145AB4
	}
	
	}
	
	.modal__text-welcome {
		font-size: 14px;
		font-weight: 600;
		color: #505050
	}
	@media (min-width: 768px) {
	
		.modal__text-welcome {
			width:400px
		}

	}

	

`;

export {
	Wrapper,
	TextCol,
	RegistryWrapper,
	FooterModalWrapper,
	AlreadyRegisteredContainer,
};
